import { useParams } from "react-router-dom";
import MakeQuote from "./MakeQuote";
import { QuoteCustomerModel } from "./QuoteModel";
import { Button, Skeleton } from "@mui/material";
import { useEffect } from "react";
import apiCall from "../../scripts/apiCall";
import { useMsal } from "@azure/msal-react";
import { observer, useLocalStore } from "mobx-react";
import React from "react";
import { toast } from "react-toastify";
import { add0 } from "../input/Functions";

const store = QuoteCustomerModel.create({});

var CreateFromSAP = ({ language, type }) => {
  let { sold, so, ship, sys, qnr } = useParams();
  qnr = add0(qnr, 10);
  const lstore = useLocalStore(() => ({
    // activeQ: false,
    selected: 0,
    // type: "",
    tryToSave: false,
    // sortdir: 1,
    // sortpar: "Validfrom", //"ValidTo"
  }));

  store.setMsal(useMsal());
  console.log(sold);
  store.setCustomer({ value: sold, label: sold, Name: sold, Id: sold });
  store.setSalesOrg({ value: so, label: so, Name: so, Id: so });

  if (!sys) {
    sys = "";
  }

  useEffect(() => {
    store.quoteData.getQuote(sold, ship, qnr, type);
    store.getSSP();

    // let sort = window.localStorage.getItem("QuoteSort");

    // if (sort !== undefined && sort !== null) {
    //   const sortObj = JSON.parse(sort);
    //   lstore.sortdir = sortObj.dir;
    //   lstore.sortpar = sortObj.par;
    // }
    apiCall(
      "Quote/GetShipInco",
      {
        method: "GET",
      },
      (results) => {
        console.log(results);
        const obj = {};
        results
          .filter((e) => e.Name !== "Views")
          .forEach((el) => {
            obj[el.name.trim()] = el.description
              .replace(/<\/?p>/g, "")
              .split(",");
          });
        store.setRelation(obj);
      },
      store.instance,
      store.accounts
    );

    let url = `SAPOData${sys}/V4`;
    apiCall(
      url,
      {
        method: "POST",
        credentials: "same-origin",
        body: JSON.stringify({
          sb: "zapi_local_interf_sb",
          proj: "zapi_local_interf_sd",
          funct: "locationHelp",
          //parameters: `$format=json`,
          parameters: `$filter=spras eq 'EN'`,
          version: "0001",
        }),
      },
      (results) => {
        console.log(results);
        console.log(results.value);
        const obj = {};
        results.value.forEach((el) => {
          obj[el.descr40.trim()] = el.Locno;
        });
        store.setInco2(obj);
      },
      store.instance,
      store.accounts
    );

    // let url2 = `SAPOData${sys}/V4`;
    // apiCall(
    //   url,
    //   {
    //     method: "POST",
    //     credentials: "same-origin",
    //     body: JSON.stringify({
    //       sb: "zapi_local_interf_sb",
    //       proj: "zapi_local_interf_sd",
    //       funct: "locationHelp",
    //       //parameters: `$format=json`,
    //       parameters: `$filter=spras eq 'EN'`,
    //       version: "0001",
    //     }),
    //   },
    //   (results) => {
    //     console.log(results);
    //     console.log(results.value);
    //     const obj = {};
    //     results.value.forEach((el) => {
    //       obj[el.descr40.trim()] = el.Locno;
    //     });
    //     store.setInco2(obj);
    //   },
    //   store.instance,
    //   store.accounts
    // );
  }, []);

  if (store.loading) {
    return ["", "", "", ""].map((el) => (
      <>
        <Skeleton animation="wave" height={120} />
        <Skeleton variant="rounded" height={100} />
      </>
    ));
  }
  if (store.SSP && store.SSP.length !== 0) {
    store.selectSSP(
      store.SSP.findIndex((value) => {
        console.log(parseInt(value.ShipTo));
        console.log(parseInt(ship));
        return parseInt(value.ShipTo) === parseInt(ship);
      })
    );

    if (store.SSPItem && store.SelectedQuote)
      return (
        <>
          <MakeQuote
            store={store}
            quote={store.SelectedQuote}
            type={type}
            trySave={false}
          />{" "}
          <Button
            color="secondary"
            variant="outlined"
            size="large"
            style={{ float: "right" }}
            onClick={(e) => {
              if (store.SelectedQuote.validShipInco) {
                if (store.SelectedQuote.validInco2) {
                  if (store.SelectedQuote.canSave) {
                    store.make(type);
                  } else {
                    toast.warn("not everything is filled in");
                    lstore.tryToSave = true;
                  }
                } else {
                  toast.warn("Inco2 not correct");
                  lstore.tryToSave = true;
                }
              } else {
                toast.error("not a valide shipment- and incoterm combination");
                lstore.tryToSave = true;
              }
            }}
          >
            {type} quote
          </Button>
        </>
      );
    return (
      <h2>
        Sold To: {sold}, Ship To: {ship}, SalesOrg:{so}, quote:{qnr} Combination
        is not found
      </h2>
    );
  }
  return "Somting Went Wrong";
};

export default observer(CreateFromSAP);
